import React from 'react';

import { Switch, Route } from 'react-router-dom';

import { AttendeeDetail } from './detail/detail';
import { AttendeeList } from './list/list';

export function Attendees({ path }) {
    return (
        <Switch>
            <Route exact path={path}>
                <AttendeeList />
            </Route>

            <Route exact path={`${path}/:attendee_id`}>
                <AttendeeDetail />
            </Route>
        </Switch>
    );
}
